<script setup lang="ts">
interface Props {
  index: number
}

defineProps<Props>()
const model = defineModel<number>({ required: true })
</script>

<template>
  <div v-if="model === index">
    <slot></slot>
  </div>
</template>
